module.exports = __webpack_public_path__ + "img/antes_despues_11.d1e04ceb.png";